// extracted by mini-css-extract-plugin
export default {"inner":"Page_inner__h3Znb"};